import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Account, useSignInMutation } from 'api/sessionApi';
import { useRecoilState } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { encryptString } from 'util/encryptUtil';

import ErrorMessage from './widget/ErrorMessage';

function SignIn() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Account>();
  const { mutate } = useSignInMutation();

  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const onSubmit: SubmitHandler<Account> = (data) => {
    mutate(data, {
      onSuccess(response) {
        if (response.code === 200) {
          const { name, latestDt, role, factoryCode } = response.info;
          setUserInfo({
            role: encryptString(role.toString()),
            name,
            latestDt,
            isAuthenticated: true,
            factoryCode,
          });
          navigate('/home/status-board');
        } else {
          alert(response.message);
        }
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={'loginbox'}>
        <h2>{'LOTO'}</h2>
        <div className={'inputbox'}>
          <dl>
            <dt>{'아이디'}</dt>
            <dd>
              <input
                type={'text'}
                {...register('account', { required: '아이디를 입력해주세요' })}
              />
            </dd>
          </dl>
          <dl>
            <dt>{'비밀번호'}</dt>
            <dd>
              <input
                type={'password'}
                {...register('passwd', { required: '비밀번호를 입력해주세요' })}
              />
            </dd>
          </dl>
          <ErrorMessage errors={errors} />
          <button type={'submit'} className={'btn-type-login'}>
            {'Login'}
          </button>
        </div>
      </div>
    </form>
  );
}

export default SignIn;
